/**
 * Does a firm steward the workspace the reader is in?
 *
 * NEW-R12-SELFMANAGED-FIRM-COPY (grader round 12): a client managing their own
 * trusts, with no firm anywhere (Firm access said "You're self-managing"), was
 * told on My trusts that "your firm grants you access" and on Security that
 * "your trust admin firm" administers recovery. Copy that names a firm has to
 * ask this first.
 *
 *   'firm'     a firm stewards this workspace.
 *   'self'     no firm does: the people in it manage it themselves.
 *   'unknown'  not known yet (loading, an unreadable workspace, an older
 *              backend): copy says neither.
 */

import type { TenantsMeResponse } from './api/tenants';

export type Stewardship = 'firm' | 'self' | 'unknown';

export function stewardshipOf(
  me: Pick<TenantsMeResponse, 'firm_stewarded' | 'self_managed'> | null | undefined,
): Stewardship {
  if (!me) return 'unknown';
  if (me.firm_stewarded === true) return 'firm';
  if (me.firm_stewarded === false) return 'self';
  // A backend older than `firm_stewarded`: `self_managed` is true only for the
  // owner of a workspace no firm stewards, so that one reader can still be
  // placed. Its false says nothing (a second member of a self-managed
  // workspace gets false too).
  if (me.self_managed === true) return 'self';
  return 'unknown';
}
